import { signal } from '@angular/core';

export const BACKEND_VERSION = signal('');
